import React, {Component, Fragment} from "react"

import authentication from "@irati/auth"
import teamService from "@irati/identity/services/teams"
import {Team} from "@irati/types"
import Button from "@irati/ui/src/Button"
import {H3} from "@irati/ui/src//Typography/Heading"
import {Para} from "@irati/ui/src/Labels"
import {FormattedMessage} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"

import CreateTeamForm from "./CreateTeamForm"

interface Props {
  setIsStepCompletable: (value: boolean) => Promise<void>
}

interface State {
  teams: Team[],
  creatingNewTeam: boolean
}

class TeamList extends Component<Props, State> {
  static getDervivedStateFromProps(props: Props, state: State) {
    props.setIsStepCompletable(!!state.teams.length)

    return {}
  }

  teamSub?: ZenObservable.Subscription

  state: State = {
    teams: [],
    creatingNewTeam: false
  }

  componentDidMount() {
    this.teamSub = teamService.watchList(authentication.business().uuid).subscribe((data) => {
      const {teams} = data.data
      this.props.setIsStepCompletable(!!teams.results?.length)
      this.setState({teams: teams.results})
    })
  }

  componentWillUnmount() {
    if (this.teamSub) {
      this.teamSub.unsubscribe()
    }
  }

  startCreateTeam = () => {
    this.setState({creatingNewTeam: true})
  }

  handleHideCreateTeam = () => {
    this.setState({creatingNewTeam: false})
  }

  handleDeleteTeam = (team: Team) => {
    teamService.delete(authentication.business().uuid, team.uuid)
  }

  render() {
    const {teams, creatingNewTeam} = this.state
    if (creatingNewTeam) {
      return <CreateTeamForm onSuccess={this.handleHideCreateTeam} onCancel={this.handleHideCreateTeam} />
    } else {
      return (
        <>
          <Flex justifyContent="space-between">
            <H3>
              <FormattedMessage id="setup_tenant.steps.teams.title" />
            </H3>
            <Button primary onClick={this.startCreateTeam}>
              <FormattedMessage id="setup_tenant.steps.teams.addTeam.text" />
            </Button>
          </Flex>
          {teams.map((team: Team) => (
            <Fragment key={team.uuid}>
              <hr />
              <Flex justifyContent="space-between">
                <Para large>{team.public_name}</Para>
                <Button onClick={() => this.handleDeleteTeam(team)}>
                  <FormattedMessage id="setup_tenant.steps.teams.deleteTeam" />
                </Button>
              </Flex>
            </Fragment>
          ))}
        </>
      )
    }
  }
}

export default TeamList
